import {ChangeDetectionPerfRecord} from "@angular/platform-browser/src/browser/tools/common_tools";

export enum ResetChange {
  RESET,
  CHANGE
}
